export const LANGUAGES = Object.freeze({
  EN: "en",
  FR: "fr",
  HI: "hi",
  ZH_CN: "zh-CN",
  DE: "de",
  ES: "es",
  VI: "vi",
  PT: "pt",
  HR: "hr",
  DA: "da",
  HMN: "hmn",
  FA: "fa",
  RU: "ru",
});

export const SUPPORTED_LANGUAGES = Object.freeze([
  { code: LANGUAGES.EN, label: "English", native: "English", country: "US" },
  { code: LANGUAGES.ZH_CN, label: "Simplified Chinese", native: "简体中文", country: "CN" },
  { code: LANGUAGES.DE, label: "German", native: "Deutsch", country: "DE" },
  { code: LANGUAGES.ES, label: "Spanish", native: "Español", country: "ES" },
  { code: LANGUAGES.FR, label: "French", native: "Français", country: "FR" },
  { code: LANGUAGES.VI, label: "Vietnamese", native: "Tiếng Việt", country: "VN" },
  { code: LANGUAGES.PT, label: "Portuguese", native: "Português", country: "PT" },
  { code: LANGUAGES.HR, label: "Croatian", native: "Hrvatski", country: "HR" },
  { code: LANGUAGES.DA, label: "Danish", native: "Dansk", country: "DK" },
  { code: LANGUAGES.HMN, label: "Hmong", native: "Hmoob", country: "US" },
  { code: LANGUAGES.FA, label: "Persian", native: "فارسی", country: "IR" },
  { code: LANGUAGES.RU, label: "Russian", native: "Русский", country: "RU" },
  { code: LANGUAGES.HI, label: "Hindi", native: "हिन्दी", country: "IN" },
]);

export const DEFAULT_LANGUAGE = LANGUAGES.EN;
